module.exports = __webpack_public_path__ + "img/stripe.e5dd261c.png";